import * as d3 from 'd3'
export default {
  methods: {

    reflash_DataSet() {
      let filterData = this.rawData

      if(this.current.area == 'OVERALL') {
        filterData = filterData.filter(f => f[this.codes.timeline])
      } else {
        filterData = filterData.filter(f => f.AREA == this.current.area && f[this.codes.timeline])
      }

      if(this.current.sheet == 'NONE') {
        this.skyline.data = filterData
      } else {
        this.skyline.data = filterData.filter(f => f[this.codes.status] == this.current.sheet)
      }

      // TURNOVER
      if(this.current.sheet == 'TURNOVER') this.skyline.data = filterData.filter(f => f.TURNOVER == 'Y')
    },



    reflash_Skyline() {
      this.reflash_DataSet() // -----> draw_Reflash.js

      d3.select('#SKYLINE_CANVAS').remove()
      d3.select('#EXCEPTION').remove()
      this.draw_SkylineCharts() // -----> setCount.js
    },



    count_Area(){
      this.area.forEach(d=> {
        if (d.code == 'OVERALL') d.count = this.rawData.length
        else d.count = this.rawData.filter(f=> f.AREA == d.code).length

        // if (this.current.sheet == 'NONE') {
        //   if (d.code == 'OVERALL') d.count = this.rawData.length
        //   else d.count = this.rawData.filter(f=> f.AREA == d.code).length

        // } else {

        //   if (d.code == 'OVERALL') d.count = this.rawData.filter(f=> this.current.sheet == d[this.codes.status]).length
        //   else d.count = this.rawData.filter(f=> f.AREA == d.code && this.current.sheet == d[this.codes.status]).length
        // }
      })
    },


    count_ITRs(){

      this.reflash_DataSet()

      this.sheet.forEach(d=> {
        if (this.current.area == 'OVERALL') {
          if(d.code == 'NONE') d.count = this.rawData.length
          else d.count = this.rawData.filter(f=> f[this.codes.status] == d.code).length
          // TURNOVER
          if(d.code == 'TURNOVER') d.count = this.rawData.filter(f=> f.TURNOVER == 'Y').length
        } else {
          if(d.code == 'NONE') d.count = this.rawData.filter(f=> f.AREA == this.current.area).length
          else d.count = this.rawData.filter(f=> f.AREA == this.current.area && f[this.codes.status] == d.code).length
          // TURNOVER
          if(d.code == 'TURNOVER') d.count = this.rawData.filter(f=> f.AREA == this.current.area && f.TURNOVER == 'Y').length
        }
        
        d3.select(`#SHT_TXT_${d.code}`).text(`${d.name} (${d.count})`)
      })
    },

  }
}
